/* eslint no-unused-vars: 0 */

var $ = require('jquery');
var _ = require('lodash');
var cookie = require('common/jquery.cookie');
var csrftoken = require('common/csrftoken');
var bootstrap = require('bootstrap/dist/js/bootstrap.js');
var bs4css = require('scss/_custom.scss');
var select2css = require('select2/select2.css');
var multiselectcss = require('bootstrap-multiselect/dist/css/bootstrap-multiselect.css');
var prodDetailCSS = require('scss/styles-prod-listing.scss');
var castingCSS = require('scss/styles-casting.scss');
var React = require('react');
var ReactDOM = require('react-dom');
var { createStore, combineReducers, applyMiddleware } = require('redux');
var { Provider } = require('react-redux');
var ReduxThunk = require('redux-thunk').default;
var router = require('react-router');
var { syncHistoryWithStore, routerReducer, routerMiddleware } = require('react-router-redux');
var { queryStringToJSON } = require('common/api/query');
var { CastingSearchApp } = require('./components/app');
var { CastingProductionDetail } = require('./components/detail');
var constants = require('./constants');
var { results } = require('./reducers/results');
var { filters } = require('./reducers/filters');
var { options } = require('./reducers/options');
var { saved } = require('./reducers/saved');
var { user } = require('common/reducers/user');
var { meta } = require('./reducers/meta');
var { seo } = require('./reducers/seo');
var { ad } = require('./reducers/ad');
var { Roles } = require('production_detail/components/roles');
var { Header } = require('header/components/header');

// All changes to state will happen inside the following redcucers
var reducers = combineReducers({ results, filters, options, saved, user, meta, seo, ad, routing: routerReducer });

// We parse the initial state from the LOCATION_CHANGE action (see fiter reducers)
var initialState = {};

// ReduxThunk - to dispatch async actions
// routerMiddleware - to dispatch router navigation actions
var middleware = applyMiddleware(ReduxThunk, routerMiddleware(router.browserHistory));

// Setup the redux store.
var store = createStore(reducers, initialState, middleware);

// Create an enhanced history that syncs navigation events with the store
var history = syncHistoryWithStore(router.browserHistory, store);
// How do I watch for navigation events, such as for analytics?
// history.listen(location => analyticsService.track(location.pathname))

// enable json cookies
$.cookie.json = true;

$(document)
  .ajaxStart(() => $('.loading').show())
  .ajaxStop(() => $('.loading').hide())
  .ready(() => {
    window._kmq = window._kmq || [];
    if (window.kmqAnalytics) {
      window._kmq.push(['identify', window.kmqAnalytics.user_email]);
      window._kmq.push(['set', window.kmqAnalytics]);
    }
  });


function onEnterCastingDetail(nextState, currentState) {
  $('body').addClass('body-no-scroll');
}

function onLeaveCastingDetail(nextState, currentState) {
  $('body').removeClass('body-no-scroll');
  document.title = 'Casting Search';
}


// Yes, we have two different rendering trees. the header is not part of the app heirarchy
ReactDOM.render(<Header />, document.getElementById('header__container'));

ReactDOM.render((
  <Provider store={store}>
    <router.Router history={history}>
      <router.Route path="casting/open-casting-calls/*" component={CastingSearchApp} />
      <router.Route path="casting" component={CastingSearchApp} >
        <router.Route path=":productionPath/" onLeave={onLeaveCastingDetail} component={CastingProductionDetail}>
            <router.IndexRoute component={Roles} onEnter={onEnterCastingDetail} />
            <router.Route path=":rolePath/" component={Roles} onEnter={onEnterCastingDetail} />
        </router.Route>
      </router.Route>
    </router.Router>
  </Provider>
), document.getElementById('main__container'));



// WEBPACK FOOTER //
// ./bso/frontend/static/js/casting/index.js